import React, { FC, useContext, useEffect, useState } from "react";
import Heading from "components/Heading/Heading";
import { DEMO_POSTS } from "data/posts";
import { PostDataType } from "data/types";


import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import Avatar from "./Avatar";
import FooterNav from "components_custom/FooterNav/FooterNav";
import { useNavigate } from "react-router-dom";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
import { GlobalDataContext } from "contexts/GlobalData";
import { requestAPI } from "utils/api";
import { ArrowSmallLeftIcon } from "@heroicons/react/24/outline";


// THIS IS DEMO FOR MAIN DEMO
// OTHER DEMO WILL PASS PROPS
const postsDemo: PostDataType[] = DEMO_POSTS.filter((_, i) => i > 7 && i < 14);
//
export interface SectionLatestPostsProps {
	posts?: PostDataType[];
	className?: string;
	postCardName?: "card3";
}

const ModifyMotorcycles: FC<SectionLatestPostsProps> = ({
	posts = postsDemo,
	postCardName = "card3",
	className = "",
}) => {

	const navigate = useNavigate ();
	//const navigationType = useNavigationType();

	const { 
		initData,
		setInitData,
	} = useContext (GlobalDataContext);
	
	let textSub = "";
	
	// const textUpdateRequired = "등록된 이름이 없어요";
	// const textSetting = "설정됨";
	
	const _motorcycleName = initData.userInfo.motorcycles;
	
	const [motorcycleName, setMotorcycleName] = useState(_motorcycleName);
	
	if (_motorcycleName === null) {
		textSub = "설정된 기종이 없어요."
	} else {
		textSub = `현재 등록된 기종은 [${_motorcycleName}]이에요.`;
		
	}

	useEffect(()=>{
		console.log("initData", initData);
		if (initData.token_info.permission_group === "guest") {

			navigate('/me')	
		}	
		
	}, []);

	

	const handleSubmit = async () => {
		const _initData = {...initData};
		const _id = _initData.userInfo._id;

		const res_info: any = await requestAPI ('PUT', `v1/user/${_id}/motorcycles`, {
			motorcycleName
		});

		if (res_info.code === 1000) {
			
			_initData.userInfo = res_info.data.userInfo;
			setInitData(_initData);
			navigate('/me');
		}
	};
	
	const handleCancel = () => {
		navigate(-1);
	};

	const handleBack = () => {
		navigate(-1);
	}

	return (
		<>
			<div className={`container relative nc-SectionLatestPosts overflow-y ${className} h-screen bg-white !p-0 lg:w-[768px]`}>
				<div className="sticky inset-0 bg-white z-40 flex items-center justify-between">
					<div className="container flex items-center justify-between sm:w-[768px] !p-0 h-[62px]">
						<div className=" top-0 pt-4 pb-4 flex items-center justify-between bg-white">
							<button
								className="focus:outline-none focus:ring-0 w-10 h-10 rounded-full flex items-center justify-center hover:bg-neutral-100 ml-2"
								onClick={()=> handleBack()}
							>
								<ArrowSmallLeftIcon className="w-6 h-6" />
							</button>
							{/* <LikeSaveBtns /> */}
							<span
								className="text-xl"
							>
								뒤로
							</span>
						</div>
					</div>
				</div>

				<div className="flex flex-col lg:flex-row">
					<div className="w-full pl-[1rem] pr-[1rem]">
						<div className="mt-5" />
						<div
							className={`nc-Section-Heading relative flex flex-col sm:flex-row sm:items-end justify-between ${className}`}
							>
							<div
								className={`max-w-2xl`}
							>
								<h2 className={`text-3xl md:text-4xl font-semibold`}>
									보유 기종 수정
								</h2>
							</div>
						</div>
						<div className="mt-10" />
						<div>
							<span
								className="text-xl font-semibold text-slate-600"
							>
								보유 기종 명을 입력해주세요
							</span>
						</div>
						<div>
							<span 
								className="text-sm text-slate-600"
							>
								{textSub}
							</span>
						</div>

						<div className="mt-10" />

						<div className="mt-10 md:ml-10 md:mr-10">
							<div className="flex justify-center items-end w-full">
								<div className="w-[180px]">
									<h2
										className={`text-lg nc-card-title text-neutral-900 dark:text-neutral-100 font-semibold`}
									>
										보유기종
									</h2>
									<span
										className={`text-sm block text-neutral-500 dark:text-neutral-400`}
									>
										<Input
											value={motorcycleName}
											onChange={e => setMotorcycleName (e.target.value)}
										/>
									</span>
								</div>	
							</div>
						</div>

						<div className="flex flex-col mt-12 space-y-5 sm:space-y-0 sm:space-x-3 sm:flex-row justify-end">
							<ButtonSecondary
								onClick={() => handleCancel()}
							>
								취소
							</ButtonSecondary>
							<ButtonPrimary
								onClick={() => handleSubmit()}
							>
								수정
							</ButtonPrimary>
						</div>						
						

					</div>

				</div>
				
			</div>
		</>
	);
};

export default ModifyMotorcycles;
